<template>
  <div>
    <div class='pm-right' ref='pmRight'>
      <canvas id='canvas' v-loading='loading'></canvas>
      <!-- 右键删除 -->
      <div v-if="deletePoint"
           @contextmenu.prevent
           class="tooltips-div color-theme border bg-white"
           :style="{top: deletePoint.pos.y + 20 + 'px', left: deletePoint.pos.x + 'px'}"
      >
        <i class="el-icon-circle-close color-red font-16" style="position: absolute; top:5px; right:5px;z-index: 999;cursor: pointer;" @click="deletePoint = null"></i>
        <div>
          <el-button @click="handleDelConfirm">{{ $t('integration.delete_anchor_points') }}</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import bus from '@/utils/bus.js'
import { getInstance } from '@/utils/planUtil-mf.js'

export default {
  props: ['pmObj', 'treeObj', 'newInfo', 'loading'],
  watch: {
    pmObj: {
      handler (newVal) {
        this.pmNewObj = { ...newVal }
        this.$nextTick(() => {
          this.initCanvas() //确保 DOM 渲染完再执行
        })
      },
      deep: true,
      immediate: true

    },
    // 选择设备进行渲染
    newInfo (newVal) {
      console.log('newInfo ->' , newVal)
      this.deviceInfo = newVal ? { ...newVal } : null

      // 锚点回显
      const param = {
        nameParam: 'title',
        statusParam: 'abnormal'
      }
      const pointList = this.pmNewObj.positionList

      const idx = pointList.findIndex(item => {
        return item.id === this.deviceInfo?.id
      })
      // 设置某一项激活
      this.initPoint(pointList, { active: idx, ...param })
    }
  },
  data () {
    return {
      // canvas对象
      myCanvas: null,
      // canvas 上下文
      canvasCtx: null,
      // 传递的数据
      pmNewObj: {},
      // 借用老版本的类
      planModule: null,
      // 所有的挂载点数据
      pointList: [],
      // 数据
      deviceInfo: '',
      Img: '',
      down: false,
      isMove: true,

      timer: null,
      deletePoint: null,
      // 当前鼠标移动到选择的点，显示tooltip的描点
      selectPoint: null,
      selectedItem: null
    }
  },
  mounted () {
    this.initCanvas()

    bus.$on('refreshPoint', array => {
      this.planModule.refresh(true)

      this.putPoint(array)
    })
    bus.$on('uploadFile', base64 => {
      this.planModule.setData([], true, true)
      this.initImage(base64)
    })
    bus.$on('updatePmObjPoint', pointList => {
      console.log("updatePmObjPoint -> ",pointList)
      this.pmNewObj.positionList = pointList
    })

    this.zoomFns()
    this.delPonits()
  },
  beforeDestroy () {
    bus.$off('refreshPoint')
    bus.$off('uploadFile')
    bus.$off('zoomFn')
    bus.$off('delPonit')
    bus.$off('updatePmObjPoint')
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {

    initCanvas () {
      this.myCanvas = document.querySelector('#canvas')
      this.canvasCtx = this.myCanvas.getContext('2d')
      this.myCanvas.height = 430
      this.myCanvas.width = 820
      this.initParam()
    },
    // 清除画布
    clearRect () {
      this.canvasCtx.clearRect(0, 0, this.myCanvas.width, this.myCanvas.height)
    },
    // 绘制画布
    initParam () {
      let that = this
      that.$nextTick(function () {
        if (!that.planModule) {
          that.planModule = getInstance({
            id: 'canvas',
            move: that.isMove, //是否可移动
            wheelZoom: that.isWheelZoom, // 是否可缩放
            mouseup: async function (img, down, drop, data, x, y, pos, target, e) {

              console.log("mouseup -> ", data);

              if (e.button == 2){
                if (target){
                  that.deletePoint = target
                }
                return
              }

              // 非左键
              if (e.button !== 0) return

              that.deletePoint = null

              if (target) return

              if (!that.deviceInfo) return that.$message.warning($t('integration.code_cannot_be_empty'));


              // 判断设备是否已绑定其他平面图
              if (that.deviceInfo.obj?.scenePlanId && that.deviceInfo.obj.scenePlanId !== that.pmNewObj.planId) {
                try {
                  await that.$confirm(that.$t('integration.device_plan_location_tips'));
                } catch {
                  // 用户点击“取消”
                  return;
                }
              }
              let temp = {}

              if (data) {
                const idx = data.findIndex(item => item.id === that.deviceInfo.id)
                console.log("mouseup  idx ->  ",idx)
                temp = {
                  xpos: x,
                  ypos: y
                }
                if (idx !== -1) {
                  data[idx].xpos = x
                  data[idx].ypos = y
                  that.pmNewObj.positionList[idx].xpos = x
                  that.pmNewObj.positionList[idx].ypos = y
                  temp = data[idx]
                } else {
                  temp.idx = idx
                  temp.xpos = x
                  temp.ypos = y
                  temp.type = that.deviceInfo.type
                  temp.title = that.deviceInfo.title
                  temp.id = that.deviceInfo.id
                  temp.obj = that.deviceInfo.obj
                  data.push(temp)
                  that.pmNewObj.positionList.push(temp);
                }
                that.$emit('xyPosFn', temp)

              }
              that.planModule.drawImg('title', 'abnormal');
            },
            mousemove: function (down, drop, data, pos, target, e) {
            }
          })
        }

        this.initImage()
        this.putPoint(this.pmNewObj.positionList)
      })
    },
    // 重新瞄点
    putPoint (array) {
      this.planModule.setData([], true, true)
      // 如果存在锚点
      if (array && array.length > 0) {
        const param = {
          nameParam: 'device_code',
          statusParam: 'abnormal'
          // carrierTypeParam: 'computed_type',
          // color: 'var(--primary-color)'
        }
        this.initPoint(array, param)
        // this.myCanvas.style.cursor = 'pointer';

      }
    },
    windowToCanvas (canvas, x, y) {
      var box = canvas.getBoundingClientRect()
      return {
        x: x - box.left - (box.width - canvas.width) / 2,
        y: y - box.top - (box.height - canvas.height) / 2
      }
    },
    initImage (img) {
      // console.log('initImage', img, this.pmNewObj['base64Path'])
      this.planModule.draw([], img || this.pmNewObj['base64Path'])
    },
    //初始化瞄点
    initPoint (array = '', param) {

      this.planModule.flashing = true
      // 设备锚点名称字段
      this.planModule.setData([], true, true, param)
      if (!array) return
      this.planModule.setData(array, true, true, param)

    },
    zoomFns () {
      bus.$on('zoomFn', value => {
        if (value < 0) {
          // 缩小
          this.planModule.zoomOut(Math.abs(value))
        } else if (value > 0) {
          // 放大
          this.planModule.zoomIn(value)
        } else {
          this.planModule.zoomIn(value)
        }
      })
    },
    // 移除锚点
    delPonits () {
      bus.$on('delPonit', () => {
        this.planModule.setData([], true, true)
      })
    },
    handleDelConfirm () {
      if (this.deletePoint) {
        bus.$emit('delPosition', this.deletePoint.data)
      }
      this.deletePoint = null
    },
    selectItemChange(val, type) {
      if (this.selectedItem === val) return
      this.selectedItem = val
      this.changeDeviceFn()
    },
    changeDeviceFn() {

    },

  }
}
</script>

<style lang='scss' scoped>
.pm-right {
  flex: 1;
  //padding: 10px;
  box-sizing: border-box;
  color: transparent;
  border: 1px solid #ccc;
  margin-left: 10px;
  width: 100%;
  height: 100%;
}
.tooltips-div{
  position: absolute;
  padding: 20px;
}
</style>
